<template>
  <Modal
    title="Profile completeness"
    description="Now you can tell how complete a profile is by checking the percentage indicated on the table, it's that simple."
    @primary-click="$emit('show-modal', false)"
    @secondary-click="$emit('show-modal', false)"
    @close-modal="$emit('show-modal', false)"
    :modal-showing="modalShowing"
  >
    <div class="py-6 px-8 border-t border-gray-lighter border-solid">
      <div class="mb-4">
        <h4 class="text-grey-darkest text-sm" style="font-weight: 600;">
          20% - Just started
        </h4>
        <p class="text-gray-gray text-sm">
          Your partner has accepted your invite and started completing their
          profile. The profile contains partner name, contact name and email
          address.
        </p>
      </div>
      <div class="mb-4">
        <h4 class="text-grey-darkest text-sm" style="font-weight: 600;">
          40% - Getting there
        </h4>
        <p class="text-gray-gray text-sm">
          The profile now also contains their website URL and a logo, a country
          and state or city.
        </p>
      </div>
      <div class="mb-4">
        <h4 class="text-grey-darkest text-sm" style="font-weight: 600;">
          60% - Got the basics
        </h4>
        <p class="text-gray-gray text-sm">
          The profile has a summary added too.
        </p>
      </div>
      <div class="mb-4">
        <h4 class="text-grey-darkest text-sm" style="font-weight: 600;">
          80% - Almost done
        </h4>
        <p class="text-gray-gray text-sm">
          The profile has at least one filter option selected.
        </p>
      </div>
      <div class="mb-4">
        <h4 class="text-grey-darkest text-sm" style="font-weight: 600;">
          100% - Profile complete
        </h4>
        <p class="text-gray-gray text-sm">
          All fields have the minimum completed. Yay!
        </p>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/DesignSystem/Modal';
export default {
  name: 'ProfileCompletenessModal',
  components: {
    Modal,
  },
  props: {
    modalShowing: {
      type: Boolean,
    },
  },
};
</script>

<style scoped></style>
